import { render, staticRenderFns } from "./BImageImgix.vue?vue&type=template&id=f7fd9aac"
import script from "./BImageImgix.vue?vue&type=script&lang=js"
export * from "./BImageImgix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports